import React, { useEffect, useMemo, useState } from 'react';
import { Portal, svgSprite } from '../../../../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../../../../common/utils/windowDimensions';
import { getCategoriesAll, getCategoriesMobile, icons } from '../helpers';
import T, { t } from '../../../../../../common/components/T';
import css from './IconsModal.module.scss';
import classnames from 'classnames';
import FormInput from '../../../form-input/FormInput/FormInput';
import GridNoData from '../../../../../plug/GridNoData/GridNoData';

const IconsModal = ({ closeHandler, setFormData, translation, value }) => {
    const [activeItem, setActiveItem] = useState(icons.find((item) => item.name === value));
    const widthDimensions = useWindowDimensions();
    const categoriesAll = useMemo(() => getCategoriesAll(), []);
    const categoriesMobile = useMemo(() => getCategoriesMobile(), []);
    const isMobileApp = widthDimensions < 768;
    const [activeTab, setActiveTab] = useState(isMobileApp ? categoriesMobile[0].name : categoriesAll[0].name);
    const [iconsList, setIconsList] = useState(icons);
    const isSearchTabActive = activeTab === 'searchTab';
    const categories = isMobileApp ? categoriesMobile : categoriesAll;
    useEffect(() => {
        const categoriesSelect = isMobileApp ? categoriesMobile[0].name : categoriesAll[0].name;
        setActiveTab(categoriesSelect);
    }, [categoriesAll, categoriesMobile, isMobileApp]);
    const chooseIcon = (icon) => {
        setActiveItem(icon);
    };
    const saveIcon = () => {
        setFormData('icon', activeItem.name);
        closeHandler();
    };
    const searchInput = (
        <div className={css.searchInput}>
            <FormInput
                handlers={{
                    onChange: (val) => {
                        if (!val) {
                            setIconsList(icons);
                        } else {
                            const filteredIcons = icons.filter((item) => item.name.toLowerCase().includes(val.toLowerCase()));
                            setIconsList([...filteredIcons].sort((a, b) => a.title.localeCompare(b.title)));
                        }
                    }
                }}
                search={{ icon: 'search-thin', type: 'onInput' }}
                placeholder={t('iconsModal-placeholder', 'Введите название иконки', 'widget', translation, 'form')}
            />
        </div>
    );

    return (
        <Portal customClass={!isMobileApp ? 'modal' : 'modalBottom'} fullWidth={!isMobileApp} closeHandler={closeHandler}>
            <div className={css.modalIconsWrapper}>
                <div className={css.modalIconsHeader}>
                    {isMobileApp ? (
                        <div onClick={closeHandler} />
                    ) : (
                        <div onClick={closeHandler} className={css.modalIconsClose}>
                            {svgSprite('cross', {
                                className: css.modalIconsCloseSvg,
                                fill: 'var(--greyExtraDarkColor)'
                            })}
                        </div>
                    )}
                    <p className={css.modalIconsTitle}>{t('iconsModal-text-1', 'Выбор иконки', 'widget', translation, 'form')}</p>
                </div>
                <div className={css.modalIconsBody}>
                    <div className={css.category}>
                        <div className={css.modalCategoryTitle}>
                            {!isMobileApp && <p>{t('iconsModal-text-3', 'Наборы иконок', 'widget', translation, 'form')}</p>}
                        </div>
                        <div>
                            {isMobileApp && searchInput}
                            {categories.map((category, index) => (
                                <div
                                    key={index}
                                    style={isMobileApp ? { pointerEvents: 'none' } : {}}
                                    className={classnames(css.categories, activeTab === category.name ? css.selectCategory : {})}
                                    onClick={() => setActiveTab(category.name)}
                                >
                                    <div className={css.modalCategoryName}>
                                        {svgSprite(category.icon, {
                                            width: '18px',
                                            height: '18px',
                                            style: { minWidth: '18px' },
                                            fill: activeTab === category.name ? '#435FC5' : '#8F8FAB'
                                        })}
                                        <p style={{ marginLeft: '10px' }}>{category.title}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={css.wrapperIcons}>
                        {isSearchTabActive && searchInput}

                        {iconsList?.length ? (
                            <div className={css.viewIcons}>
                                {iconsList?.map((icon, index) => (
                                    <div
                                        key={index}
                                        onClick={() => chooseIcon(icon)}
                                        className={classnames(
                                            css.selectIcon,
                                            activeItem === icon ? css.selectIconActive : {},
                                            css[`icons_modal_${icon?.size}`]
                                        )}
                                        style={{
                                            ...(icon?.size === 'large' ? { gridColumn: 'span 2' } : {}),
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            padding: '5px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {activeItem === icon
                                            ? svgSprite('check-circle-fill', {
                                                  className: css.agreeIcon
                                              })
                                            : ''}
                                        {svgSprite(
                                            icon?.name,
                                            {
                                                width: icon?.size === 'large' ? '130px' : '30px',
                                                height: icon?.size === 'large' ? '130px' : '30px',
                                                fill: '#000'
                                            },
                                            'icons',
                                            ['394', '109']
                                        )}
                                        <p
                                            style={{
                                                fontSize: '12px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {' '}
                                            {icon?.title}{' '}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <GridNoData
                                title={t(
                                    'noDataAlert-sm',
                                    'По Вашему запросу не было найдено ни одного совпадения.',
                                    'widget',
                                    translation,
                                    'form'
                                )}
                            />
                        )}
                    </div>
                </div>
                <div className={css.modalIconsFooter}>
                    <div className={css.modalIconsBtnFooter}>
                        {isMobileApp && (
                            <div className={css.iconsButtonCancel} onClick={closeHandler}>
                                <p>
                                    <T textName='cancel' defaultStr='Отмена' page='all' />
                                </p>
                            </div>
                        )}
                        <div className={css.iconsButtonSave} onClick={saveIcon}>
                            <p>
                                {isMobileApp ? (
                                    <T textName='select' defaultStr='Выбрать' page='all' />
                                ) : (
                                    t('iconsButtonSave', 'Выбрать иконку', 'widget', translation, 'form')
                                )}
                            </p>
                        </div>
                        <div className={css.iconsTextCategories}>
                            <p>{t('iconsModal-text-7', 'Поиск иконок', 'widget', translation, 'form')}</p>
                            <p>{t('iconsModal-text-4', 'Системная библиотека', 'widget', translation, 'form')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    );
};
export default React.memo(IconsModal);
